import type { ReactNode } from 'react';
import { useOutletContext } from 'react-router-dom';
import type { Meta } from '@upbeat/shared';
import type { FiltersQuery } from '@upbeat/shared';
import type { FilterState } from '../state/filters';
import { FilterLine } from '../components/FilterLine';

export interface PageContext {
  meta: Meta | undefined;
  state: FilterState | null;
  query: FiltersQuery | null;
  country?: string | null;
  setCountry?: (country: string | null) => void;
  selectedCountries?: string[];
  setSelectedCountries?: (countries: string[] | ((prev: string[]) => string[])) => void;
}

export const usePage = () => useOutletContext<PageContext>();

/** Page heading in the design's `.shead` style, followed by the active filter line. */
export function PageShell({ title, note, children }: { title: ReactNode; note?: ReactNode; children: ReactNode }) {
  const { meta, state } = usePage();
  return (
    <>
      <section className="section page-header">
        <div className="shead">
          <h2>{title}</h2>
          {note ? <div className="note">{note}</div> : null}
        </div>
        {meta && state ? <FilterLine state={state} meta={meta} /> : null}
      </section>
      {children}
    </>
  );
}
